export default __webpack_public_path__ + "static/media/BestSellingMobile.c29f181d.png";